<div class="layout-topbar">
  <div class="layout-topbar-start">
    <a
      class="layout-topbar-logo"
      routerLink="/"
    >
      <p-image
        src="assets/logo/icon.png"
        width="80"
        alt="pflegix-logo"
      />
    </a>

    <a
      #menuButton
      class="layout-menu-button"
      (click)="onMenuButtonClick()"
    >
      <i class="pi pi-chevron-right"></i>
    </a>

    <a
      #mobileMenuButton
      class="layout-topbar-mobile-button"
      (click)="onMobileTopbarMenuButtonClick()"
    >
      <i class="pi pi-ellipsis-v"></i>
    </a>
    <div class="flex flex-grow items-center ml-4 flex-wrap">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>

  <div class="layout-topbar-end">
    <div class="layout-topbar-actions-end ml-auto">
      <ul class="layout-topbar-items">
        @if ('read' | ablePure: appSubjects.globalSearch | async) {
          <li class="layout-topbar-search">
            <pfx-global-search
              #searchInput
              (selectedModel)="handleSelectedModel($event)"
            ></pfx-global-search>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
